Vue.component('ack-installation-portal', {
    delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
    template: '#ack-installation-portal',
    mixins: [languageMixins],
    created() {

    },
    mounted() {
      appLog.log('ack-installation-portal mounted')
      this.setPageIsLoading(false)
    },
    props:{
      // dataIn: {
      //   type: Object,
      //   required: true
      // }

    },
    computed: {
      //...Vuex.mapGetters('sliders', ['slidersLists']),
      //...Vuex.mapGetters('articles', ['articlesArray']),
      isMobile(){
        return this.$parent.isMobile
      },
    },
    data() {
      return {
        pageId: 'installation-portal-page',
        printerGroupTitle: '3D Printers',
        curingUnitGroupTitle: 'Curing Units',
        steps: [
            /*
              {
                title: 'Step 1: Unboxing your Concierge Box',
                resources: [
                  {
                    title: 'USA/CANADA: Unbox Concierge Service',
                    link: 'https:\/\/ackuretta.com\/pages\/video-gallery?videoId=zTzIC7-jKG8',
                    image: 'https:\/\/img.youtube.com\/vi\/zTzIC7-jKG8\/mqdefault.jpg',
                    logo_image: 'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//Flag-icon.png?v=1697443133',
                    description: 'This video shows what to do when you first receive your Ackuretta 3D printer.'
                  },
                ]
              },
            */
            {
              title: 'Step 1: Unboxing your Ackuretta 3D Printer Solution',
              resources: [
                {
                  title: 'SOL Plus – Unboxing with Concierge service',
                  link: 'https:\/\/ackuretta.com\/pages\/video-gallery?videoId=tdSGS6y2bpo',
                  image: 'https://img.youtube.com/vi/tdSGS6y2bpo/mqdefault.jpg',
                  logo_image: 'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//Flag-icon.png?v=1697443133',
                  description: 'This video shows what you can expect to do when you first receive your SOL Plus with Concierge service.'
                },
                {
                  title: 'SOL – Unboxing Your Printer',
                  link: 'https:\/\/ackuretta.com\/pages\/video-gallery?videoId=EsgMKUlF0-c',
                  image: 'https://img.youtube.com/vi/EsgMKUlF0-c/mqdefault.jpg',
                  description: 'This video shows what you can expect to do when you first receive your SOL 3D printer.'
                },
                {
                  title: 'SOL – Unboxing SOL with Concierge service',
                  link: 'https:\/\/www.youtube.com\/watch?v=SRdK7UONX94',
                  image: 'https:\/\/img.youtube.com\/vi\/SRdK7UONX94\/mqdefault.jpg',
                  logo_image: 'https://cdn.shopify.com//s//files//1//0276//4174//1415//files//Flag-icon.png?v=1697443133',
                  description: 'This video shows what you can expect to do when you first receive your SOL 3D printer with Concierge service.'
                },
                {
                  title: 'DENTIQ – Unboxing Your Printer',
                  link: 'https:\/\/www.youtube.com\/watch?v=_UWaNvT5dwY',
                  image: 'https:\/\/img.youtube.com\/vi\/_UWaNvT5dwY\/mqdefault.jpg',
                  description: 'This short video shows you the quick and simple process of unboxing your Ackuretta DENTIQ 3D printer.'
                },
                {
                  title: 'CLEANI - Unbox your wash Unit',
                  link: 'https://ackuretta.com/pages/video-gallery?videoId=R6KDUTq1w5E',
                  image: 'https:\/\/img.youtube.com\/vi\/R6KDUTq1w5E\/mqdefault.jpg',
                  description: 'This video shows what to do when you first receive your CLEANI Tank Plus Washer for 3D Printed Dental Applications.'
                },
                {
                  title: 'Unboxing CURIE Plus',
                  link: 'https:\/\/ackuretta.com\/pages\/video-gallery?videoId=OaZWPfDRTM0',
                  image: 'https:\/\/img.youtube.com\/vi\/OaZWPfDRTM0\/mqdefault.jpg',
                  description: 'This video shows what to do when you first receive your CURIE Plus.'
                },
                {
                  title: 'CURIE - Unbox your curing oven',
                  link: 'https:\/\/ackuretta.com\/pages\/video-gallery?videoId=hKkn6tftrWQ',
                  image: 'https:\/\/img.youtube.com\/vi\/hKkn6tftrWQ\/mqdefault.jpg',
                  description: 'This video shows what to do when you first receive your CURIE.'
                },
                {
                  title: 'NFinity - Unboxing NFinity',
                  link: `https://ackuretta.com/pages/video-gallery?videoId=txWD2sNgCL0`,
                  image: `https://img.youtube.com/vi/txWD2sNgCL0/mqdefault.jpg`,
                  description: 'This video shows what to do when you first receive your NFinity.'
                },
              ]
            },
        ],
        step_setup: {
          title: 'Step 2: Product Setup',
          resources: [
            {
              title: '3D Printer',
              items: [
                {
                  title: 'SOL – Connecting SOL to Internet',
                  link: 'https:\/\/ackuretta.com\/pages\/video-gallery?videoId=YkhRAayWjqw',
                  image: 'https:\/\/img.youtube.com\/vi\/YkhRAayWjqw\/mqdefault.jpg',
                  description: 'This video shows how to connect your SOL 3D printer to a local network using either Wi-Fi or a wired connection.'
                },
                {
                  title: "SOL – Updating the Firmware",
                  link: "https:\/\/ackuretta.com\/pages\/video-gallery?videoId=R2Q6T4RKuW8",
                  image: "https:\/\/img.youtube.com\/vi\/R2Q6T4RKuW8\/mqdefault.jpg",
                  description: "When you are connected to the internet, updating the firmware on your printer only takes a moment. This video shows you how."
                },
                {
                  title: "SOL – Heater Setup",
                  link: "https:\/\/ackuretta.com\/pages\/video-gallery?videoId=uQ7fpYUh67c",
                  image: "https:\/\/img.youtube.com\/vi\/uQ7fpYUh67c\/mqdefault.jpg",
                  description: "This video tutorial that provides instructions on how to set up the heater in a SOL device."
                },
                {
                  title: 'SOL Plus – Connecting SOL to Internet',
                  link: 'https://ackuretta.com/pages/video-gallery?videoId=vcfWKuLmY5E',
                  image: 'https:\/\/img.youtube.com\/vi\/vcfWKuLmY5E\/mqdefault.jpg',
                  description: 'This video shows how to connect your SOL 3D printer to a local network using either Wi-Fi or a wired connection.'
                },
                {
                  title: "SOL Plus – Updating the Firmware",
                  link: "https://ackuretta.com/pages/video-gallery?videoId=pLGAyN5S8wM",
                  image: "https:\/\/img.youtube.com\/vi\/pLGAyN5S8wM\/mqdefault.jpg",
                  description: "When you are connected to the internet, updating the firmware on your printer only takes a moment. This video shows you how."
                },

              ]
            },
            {
              title: 'Curing Unit',
              items: [
                {
                  title: "CURIE Plus - Connecting CURIE Plus to Internet",
                  link: "https:\/\/ackuretta.com\/pages\/video-gallery?videoId=iEIXkm7EMiQ",
                  image: "https:\/\/img.youtube.com\/vi\/iEIXkm7EMiQ\/mqdefault.jpg",
                  description: "When you are connected to the internet, updating the firmware on your printer only takes a moment. This video shows you how."
                },
                {
                  title: "CURIE Plus - Updating the Firmware",
                  link: "https:\/\/ackuretta.com\/pages\/video-gallery?videoId=iEIXkm7EMiQ",
                  image: "https:\/\/img.youtube.com\/vi\/iEIXkm7EMiQ\/mqdefault.jpg",
                  description: "When you are connected to the internet, updating the firmware on your printer only takes a moment. This video shows you how."
                },
                {
                  title: "CURIE Plus - Before Using NFinity",
                  link: `https://ackuretta.com/pages/video-gallery?videoId=5xSGp36tr-w`,
                  image: `https://img.youtube.com/vi/5xSGp36tr-w/mqdefault.jpg`,
                  description: "Learn what you need to start using NFinity with our setup video."
                },
                {
                  title: "CURIE Plus - Setting Up CURIE Plus and NFinity",
                  link: `https://ackuretta.com/pages/video-gallery?videoId=QUkVDuk0X8Y`,
                  image: `https://img.youtube.com/vi/QUkVDuk0X8Y/mqdefault.jpg`,
                  description: "Learn how to set up your NFinity and connect it to CURIE Plus to enjoy the benefits of curing your dental applications with nitrogen - including enhanced esthetics and mechanical properties."
                },
              ]
            },
          ]
        },
        step_alpha:[
          {
            title: 'Step 3: Download ALPHA AI Slicing Software',
            resources: [
                {
                    title: "ALPHA AI - How to Download & Upgrade ALPHA AI",
                    link: "https://ackuretta.com/pages/video-gallery?videoId=VoLbCy4sE-4",
                    image: "https:\/\/img.youtube.com\/vi\/VoLbCy4sE-4\/mqdefault.jpg",
                    description: "Download ALPHA AI for free, and take advantage of all the original features."
                }
            ]
          }
        ],
        step_list: {
            title: 'Step 4: Additional Materials Required for 3D Printing',
            headline: 'The following consumables are required for processing 3D printing and should be purchased prior to starting your first 3D print.',
            resources: [
              {
                title: '1. Isopropyl Alcohol (IPA) <95% or higher',
                sub_title: 'Additionally, we recommend purchasing:',
                image: 'https:\/\/cdn.shopify.com\/s\/files\/1\/0276\/4174\/1415\/files\/95__Isopropyl-alcohol.png?v=1698720318',
                list: [
                  'CLEANI requires up to 0.5 gallons (2l) of IPA per tank.',
                  'Alcohol wipes.',
                  'Spray bottle for cleaning delicate prints.'
                ],
              },
              {
                title: '2. Blue Shop Towels or High Absorbance Paper Towels',
                image: 'https:\/\/cdn.shopify.com\/s\/files\/1\/0276\/4174\/1415\/files\/Blue-Shop-Towel.png?v=1697443133',
                list: [
                  'Blue Shop Towels are ideal as a protective layer between your counter and your 3D printing setup due to high liquid absorption.',
                ],
              },
              {
                title: '3. Air Blower or Air Compressor',
                image: 'https:\/\/cdn.shopify.com\/s\/files\/1\/0276\/4174\/1415\/files\/Air-Blower.png?v=1697443133',
                list: [
                  'After washing your 3D printed applications, you will need to dry them using an air blower or compressed air.',
                ],
              },
              {
                title: '4. Rubber Gloves',
                image: 'https:\/\/cdn.shopify.com\/s\/files\/1\/0276\/4174\/1415\/files\/Rubber-Gloves.png?v=1697443133',
                list: [
                  'Resins and IPA can have a corrosive effect on your ski, to prevent contact, please always wear gloves when handling IPA or uncured resins.',
                ],
              },
            ]
        }
      }
    },
    methods: {
      ...Vuex.mapActions(['setPageIsLoading'])
      //...Vuex.mapActions('sliders', ['getSlideList'])




    },
    beforeDestroy() {

    },
    watch: {

      data1: {
        handler() {



        },
        deep: false
      }
    }
  })